import { Box, SxProps, Typography } from '@mui/material';
import { deepmerge } from '@mui/utils';

const boxStyle = {
  padding: 7,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  gap: 0.625,
} as const;

type Props = {
  title: string;
  description?: string;
  withBackground?: boolean;
  sx?: SxProps;
};

export const NoData = ({ title, description, withBackground = false, sx = {} }: Props) => {
  const backgroundStyle: SxProps = withBackground
    ? {
        backgroundImage: `url("/assets/chart-data-background.png")`,
        backgroundPosition: 'top center',
        backgroundSize: 'cover',
        backgroundRepeat: 'none',
      }
    : {};

  const style = deepmerge(deepmerge(boxStyle, backgroundStyle), sx);

  return (
    <Box sx={style} data-role="blank-data-state">
      <Typography variant="subtitle2" component={'span'}>
        {title}
      </Typography>
      {description && <Typography variant="caption">{description}</Typography>}
    </Box>
  );
};
